import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuthenticationContext } from "../Authentication";
import { useTokenCallContext } from "../TokenCall";

const CartInventoryContext = createContext();

export const CartInventoryProvider = ({ children }) => {
  const { sessionAccountId, sessionCustomerId, sessionOpportunityId } =
    useAuthenticationContext();
  const { fetchToken } = useTokenCallContext()
  const [cartProduct, setCartProduct] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [customerOption, setCustomerOption] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalMSRP, setTotalMSRP] = useState(0);
  const [activeAccount, setActiveAccount] = useState([]);
  const [newcustomerOption, setnewCustomerOption] = useState([]);
  const [currentPath, setCurrentPath] = useState(null);// Amit
  const [userData, setUserData] = useState(null);
  const [isUserDataFetched, setIsUserDataFetched] = useState(false);
  const [ownerInfo, setOwnerInfo] = useState(null);
  // Amit
  const [infoList, setInfoList] = useState([]);
  const columns = [
    { key: "image", label: "Image", width: "100px" },
    { key: "sku", label: "SKU", width: "80px" },
    { key: "brand", label: "Brand", width: "100px" },
    { key: "productName", label: "Product Name", width: "140px" },
    { key: "color", label: "Color", width: "60px" },
    { key: "size", label: "Size", width: "60px" },
    { key: "upcNumber", label: "UPC", width: "150px" },
    { key: "availableQuantity", label: "Available Quantity", width: "60px" },
    { key: "requestedQuantity", label: "Requested Quantity", width: "100px" },
    { key: "price", label: "Price", width: "80px" },
    { key: "MSRP", label: "MSRP", width: "80px" },
    { key: "counterOffer", label: "Offer Price", width: "100px" },
  ];
 
  // feedaback change as it needs to reorder the fileds
 
  const columnsRepl = [
    { key: "image", label: "Image", width: "100px" },
    { key: "sku", label: "SKU", width: "80px" },
    { key: "brand", label: "Brand", width: "100px" },
    { key: "productName", label: "Product Name", width: "140px" },
    { key: "color", label: "Color", width: "60px" },
    { key: "size", label: "Size", width: "60px" },
    { key: "upcNumber", label: "UPC", width: "150px" },
    { key: "availableQuantity", label: "Available Quantity", width: "60px" },
    { key: "requestedQuantity", label: "Requested Quantity", width: "100px" },
    { key: "price", label: "Price", width: "80px" }
  ];
  
  const [visibleColumns, setVisibleColumns] = useState(
    columns.map((col) => col.key)
  );
  const [visibleColumnsRepl, setVisibleColumnsRepl] = useState(
    columnsRepl.map((col) => col.key)
  );
  const storeCartDataInSession = (cartData) => {
    sessionStorage.setItem("cartProduct", JSON.stringify(cartData));

    const total = cartData.reduce(
      (acc, item) => {
        if (item.nyc_atuid != undefined) {
          return parseFloat(acc + (item.requestedQuantity || 0) * (item.nyc_price || 0))
        }
        return acc + (item.requestedQuantity || 0) * (item.counterOffer || 0);
      }, 0
    );
    const msrpTotal = cartData.reduce(
      (acc, item) => acc + (item.requestedQuantity || 0) * (item.nyc_msrp || 0),
      0
    );
    sessionStorage.setItem("totalPrice", total);
    sessionStorage.setItem("totalMSRP", msrpTotal);
    setTotalPrice(total);
    setTotalMSRP(msrpTotal);
  };

  const fetchCartDataFromCache = async () => {
    const cacheName = "cart-product-cache";
    const cacheStorage = await caches.open(cacheName);
    const cacheUrl = "/home/cart-data";
    try {
      const cachedResponse = await cacheStorage.match(cacheUrl);

      if (cachedResponse) {
        const cachedData = await cachedResponse.json();
        // console.log("Data fetched from cache:", cachedData);
        setCartProduct(cachedData);
        storeCartDataInSession(cachedData);
        setIsLoading(false);
        return cachedData;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching data from cache:", error);
      throw error;
    }
  };
  const fetchDataFromUserCache = async () => {
    try {
      const cache = await caches.open('user-data-cache');
      const request = new Request('/user-data');
      const cachedResponse = await cache.match(request);

      if (cachedResponse) {
        const data = await cachedResponse.json();
        return data;
      } else {
        // console.log('Data not found in cache.');
        return {};
      }
    } catch (err) {
      console.error('Failed to fetch data from cache:', err);
      return {};
    }
  };
  const fetchAccountNames = async () => {
    const data = await fetchDataFromUserCache();
    setIsLoading(true)
    const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/cart/fetch-account-names`;
    const contactGuid = data?.contactId;
    if (!contactGuid) {
      // console.log("Contact GUID is not present.");
      setIsLoading(false)
      return;
    }

    try {
      // console.log("contactGuid :", contactGuid);
      const response = await axios.post(API_URL, { contactGuid });
      const accounts = response.data.accounts || [];
      const formattedAccounts = accounts.map((account) => ({
        label: account.label,
        value: account.value,
      }));
      setCustomerOption(formattedAccounts);
      setIsLoading(false)
    } catch (error) {
      // console.log("Error fetching customer options:", error);
      setIsLoading(false);
      throw error;
    }
  };

  //for the new custmer
  const fetchNewAccountNames = async () => {
    const data = await fetchDataFromUserCache();
    setIsLoading(true)
    if (!data) {
      // console.log("Account ID is not present in the session storage");
      setIsLoading(false)
      return;
    }

    try {
      const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/cart/fetch-new-account-names`;
      // console.log("Inside try block in new account");

      const response = await axios.post(API_URL, {
        accountGuid: data?.accountId,
      });
      // console.log("Fetch New Account Name", response, 159);

      const account = response.data.accounts || {};
      // console.log("Accounts here", account.name);

      const formattedAccounts = [
        {
          label: account.label || account.name,
          value: account.value || account.accountGuid,
        },
      ];

      setnewCustomerOption(formattedAccounts);
      setIsLoading(false)
    } catch (error) {
      // console.log("Error fetching Account options:", error);
      setIsLoading(false)
      throw error;
    }
  };

  //allactive account
  const fetchAllActiveAccountNames = async () => {
    setIsLoading(true)
    const API_URL1 = `${process.env.REACT_APP_SERVER_URL}/api/cart/all-active-account`;
    try {
      const response = await axios.get(API_URL1);
      const accounts = response.data.accounts || [];

      const formattedAccounts = accounts.map((account) => ({
        label: account.label,
        value: account.value,
      }));
      setActiveAccount(formattedAccounts);
      setIsLoading(false)
    } catch (error) {
      // console.log("Error fetching Account options:", error);
      setIsLoading(false)
      throw error;
    }
  };

  // console.log(activeAccount, 152);

  useEffect(() => {
    fetchCartDataFromCache();
  }, []);


  // Amit Funtion Change
  const updateCartDataInCache = async (newCartData) => {
    const cacheName = "cart-product-cache";
    const cacheStorage = await caches.open(cacheName);
    const cacheUrl = "/home/cart-data";
    // console.log("cartProduct:", cartProduct);
    var newCart = [];
    cartProduct.forEach((item) => {
      newCart.push(item);
    });
    newCartData.forEach((item) => {
      newCart.push(item);
    });
    try {
      const response = new Response(JSON.stringify(newCart));
      await cacheStorage.put(cacheUrl, response);
      setCartProduct(newCart);
      storeCartDataInSession(newCart);
      // console.log("Data stored in cache:", newCart);
    } catch (error) {
      console.error("Error storing data in cache:", error);
      throw error;
    }
  };
  const removeCartDataInCache = async (newCartData) => {
    const cacheName = "cart-product-cache";
    const cacheStorage = await caches.open(cacheName);
    const cacheUrl = "/home/cart-data";
    try {
      const response = new Response(JSON.stringify(newCartData));
      await cacheStorage.put(cacheUrl, response);
      storeCartDataInSession(newCartData);
      // console.log("Data stored in cache:", newCartData);
    } catch (error) {
      console.error("Error storing data in cache:", error);
      throw error;
    }
  };
  const deleteProduct = async (index) => {
    const newCartProducts = cartProduct.filter((_, i) => i !== index);
    setCartProduct(newCartProducts);
    toast.success("Selected Item has removed");
    await removeCartDataInCache(newCartProducts);
    calculateTotalPrice(newCartProducts);
    calculateTotalMSRP(newCartProducts);

  };

  const deleteAllProducts = async () => {
    const newCartProducts = [];
    setCartProduct(newCartProducts);
    //toast.success("All Cart Items have been removed");
    await removeCartDataInCache(newCartProducts);
  };

  const calculateTotalPrice = (items) => {
    const totalPrice = items.reduce(
      (acc, item) => {
        if (item.nyc_atuid != undefined) {
          return parseFloat(acc + (item.requestedQuantity || 0) * (item.nyc_price || 0))
        }
        return acc + (item.requestedQuantity || 0) * (item.counterOffer || 0);
      }, 0
    );
    setTotalPrice(totalPrice);
    sessionStorage.setItem("totalPrice", totalPrice);
  };

  const calculateTotalMSRP = (items) => {
    const totalMSRP = items.reduce(
      (acc, item) => acc + (item.requestedQuantity || 0) * (item.nyc_msrp || 0),
      0
    );
    setTotalMSRP(totalMSRP);
    sessionStorage.setItem("totalMSRP", totalMSRP);
  };

  const getTotalCartItem = () => {
    return cartProduct.length;
  };

  useEffect(() => {
    // console.log("Total rows:", selectedRows);
  }, [selectedRows]);

  const [inputValues, setInputValues] = useState({});
  //Deepanshu 
  const handleProductCheckboxChange = (product, isChecked) => {
    // const productWithInputs = {
    //   ...product,
    //   ...inputValues[product.productnumber],
    // };

    setSelectedRows((prevSelectedRows) => {
      if (isChecked) {
        return [...prevSelectedRows];
      } else {
        return prevSelectedRows.filter(
          (row) => row.productnumber !== product.productnumber
        );
      }
    });
  };

  // Priyanshu
  const [uncheck, setUncheck] = useState(false);
  const handleStoreInCache = () => {
    // Remove duplicate objects with the same UPC and product number
    if (selectedRows.length > 100) {
      toast.error("You can only select up to 100 items.");
      return;
    }
    const map = new Map();
    let filteredArray = [];
    // console.log("selectedRows: ", selectedRows);

    var isAtuPresent1 = false;
    var isAtuPresent2 = false;

    selectedRows.forEach((item) => {
      if (item.nyc_atuid != null) {
        isAtuPresent1 = true;
      }
    });

    cartProduct.forEach((item) => {
      if (item.nyc_atuid != null) {
        isAtuPresent2 = true;
      }
    })

    if (isAtuPresent1 !== isAtuPresent2 && cartProduct.length != 0 && selectedRows.length != 0) {
      toast.error("Remove either Replenishment or Inventory record, cannot place order for both types of record at the same time");
      return;
    }

    selectedRows.forEach(item => {
      const key = `${item.nyc_upc}-${item.productnumber}`;

      if (!map.has(key)) {
        map.set(key, item);
      } else {
        const obj = map.get(key);

        // Combine requested quantities
        const value1 = item.requestedQuantity !== undefined && item.requestedQuantity !== '' ? parseInt(item.requestedQuantity) : 0;
        const value2 = obj.requestedQuantity !== undefined ? parseInt(obj.requestedQuantity) : 0;
        obj.requestedQuantity = value2;

        // Combine counter offers
        const value3 = item.counterOffer !== undefined && item.counterOffer !== '' ? parseFloat(item.counterOffer) : 0;
        const value4 = obj.counterOffer !== undefined ? parseFloat(obj.counterOffer) : 0;
        obj.counterOffer = value4;

        map.set(key, obj);
      }
    });

    for (const value of map.values()) {
      filteredArray.push(value);
    }

    // console.log("filtered array: ", filteredArray);

    const upcArray = [];
    const infoArray = [];
    let newItems = cartProduct;

    filteredArray.forEach((selectedRow) => {
      var matchingProduct = [];

      if (selectedRow.nyc_atuid !== null) {
        matchingProduct = newItems.find(
          (product) => product.nyc_upc === selectedRow.nyc_upc && product.productnumber === selectedRow.productnumber
        );

      }
      else {
        matchingProduct = newItems.find(
          (product) => product.nyc_upc === selectedRow.nyc_upc && product.nyc_sku === selectedRow.nyc_sku
        );

      }

      // console.log("Matching product", matchingProduct);

      if (matchingProduct !== undefined) {
        const value1 = matchingProduct.requestedQuantity !== undefined ? parseInt(matchingProduct.requestedQuantity) : 0;
        const value2 = selectedRow.requestedQuantity !== undefined ? parseInt(selectedRow.requestedQuantity) : 0;
        const value3 = matchingProduct.counterOffer !== undefined ? parseFloat(matchingProduct.counterOffer) : 0;
        const value4 = selectedRow.counterOffer !== undefined ? parseFloat(selectedRow.counterOffer) : 0;

        matchingProduct.requestedQuantity = value2;
        matchingProduct.counterOffer = value4;

        if (matchingProduct.nyc_atuid !== null) {
          newItems = newItems.map((item) =>
            item.nyc_upc === matchingProduct.nyc_upc && item.productnumber === matchingProduct.productnumber
              ? { ...matchingProduct }
              : item
          );

          if (value1 === value2) {
            infoArray.push(`Cart already contains ${value1} quantity with UPC no: ${matchingProduct.nyc_upc} and product number: ${matchingProduct.productnumber}`);
          } else {
            infoArray.push(`Cart already contains ${value1} quantity with UPC no: ${matchingProduct.nyc_upc} and product number: ${matchingProduct.productnumber}, now updated quantity is ${value2}`);
          }

          upcArray.push(`${matchingProduct.nyc_upc}-${matchingProduct.productnumber}`);
        }
        else {
          newItems = newItems.map((item) =>
            item.nyc_upc === matchingProduct.nyc_upc && item.nyc_sku === matchingProduct.nyc_sku
              ? { ...matchingProduct }
              : item
          );



          if (value1 === value2) {
            infoArray.push(`Cart already contains ${value1} quantity with UPC no: ${matchingProduct.nyc_upc} and product number: ${matchingProduct["nyc_sku@OData.Community.Display.V1.FormattedValue"]}`);
          } else {
            infoArray.push(`Cart already contains ${value1} quantity with UPC no: ${matchingProduct.nyc_upc} and product number: ${matchingProduct["nyc_sku@OData.Community.Display.V1.FormattedValue"]}, now updated quantity is ${value2}`);
          }

          upcArray.push(`${matchingProduct.nyc_upc}-${matchingProduct.nyc_sku}`);
        }
      }
    });

    // console.log("newItems", newItems);
    setCartProduct(newItems);

    filteredArray = filteredArray.filter(item =>
      !upcArray.includes(`${item.nyc_upc}-${item.productnumber}`) &&
      !upcArray.includes(`${item.nyc_upc}-${item.nyc_sku}`)
    );

    setSelectedRows(filteredArray);
    setInfoList(infoArray);
    // console.log("Selected row: ", filteredArray);
    // console.log("infoArray: ", infoArray);

    updateCartDataInCache(filteredArray);
  };

  const handleAddToCartFromSearch = (searchResult) => {
    // // console.log("searching:", searchResult)
    // Check if the item is already in the cart
    setCartProduct((prevCartProducts) => {
      const existingProductIndex = prevCartProducts.findIndex(
        (cartItem) => cartItem.productnumber === searchResult.productnumber
      );

      if (existingProductIndex !== -1) {
        // If the item already exists in the cart, update the quantities
        const updatedCartProducts = [...prevCartProducts];
        const existingProduct = updatedCartProducts[existingProductIndex];
        updatedCartProducts[existingProductIndex] = {
          ...existingProduct,
          requestedQuantity: (
            parseFloat(existingProduct.requestedQuantity || 0) +
            parseFloat(searchResult.requestedQuantity || 0)
          ).toString(),
          counterOffer: (
            parseFloat(existingProduct.counterOffer || 0) +
            parseFloat(searchResult.counterOffer || 0)
          ).toString(),
        };
        return updatedCartProducts;
      } else {
        // If the item does not exist in the cart, add it
        return [...prevCartProducts, searchResult];
      }
    });
  };
  const [cartNotification, setCartNotification] = useState(null);
  const [displayThankYouPage, setDisplayThankYouPage] = useState(false)

  const handleGenerateQuote = async () => {
    setIsLoading(true);
    const data = await fetchDataFromUserCache();
    await fetchToken();
    try {
      // const tokenData = localStorage.getItem("auth-token");
      const sessionAccountGUID = sessionStorage.getItem("accountId") || null;
      // const sessionContactGUID = sessionStorage.getItem("contactId") || null;
      // const userIsSalesPerson = localStorage.getItem("validSalesPerson") === "true";
      // const sessionOpportunityGUID = sessionStorage.getItem("opportunityId") || null;
      // console.log("User Data from cache", userData)
      const tokenData = localStorage.getItem("auth-token");
      const userIsSalesPerson = localStorage.getItem("validSalesPerson") === "true";
      const sessionOpportunityGUID = localStorage.getItem("opportunityId") || null;

      // Fetch accountId and contactId from cache

      const sessionContactGUID = data.contactId || null;
      // console.log("Account GUID", sessionAccountGUID)
      // console.log("Contact GUID", sessionContactGUID)
      if (
        sessionAccountGUID.trim() !== ""
      ) {
        // Check if both ATU and Inventory record are present in the cart
        let atuRecord = 0;
        let inventoryRecord = 0;
        let cartLength = cartProduct.length;

        cartProduct.forEach((obj) => {
          if (obj.hasOwnProperty("nyc_recordtype")) {
            atuRecord++;
          } else {
            inventoryRecord++;
          }
        });

        // console.log("atuRecord: " + atuRecord + " inventoryRecord: " + inventoryRecord + " length: " + cartLength);
        if (!(atuRecord === cartLength || inventoryRecord === cartLength)) {
          setCartNotification("Remove either ATU or Inventory record, cannot place order for both types of record at the same time");
          setIsLoading(false);
          return;
        }

        // console.log("Cart Product", cartProduct, 484)

        // Check for zero price or counter offer
        // Check for zero price or counter offer

        if (inventoryRecord > 0) {
          for (let row of cartProduct) {
            const price = Number(row.price);
            const counterOffer = row.counterOffer !== undefined ? Number(row.counterOffer) : 0;
            const requestedQuantity = row.requestedQuantity !== undefined ? Number(row.requestedQuantity) : 0;

            if (row.producttypecode != 3) {
              if (price === 0 && counterOffer === 0) {
                toast.error(`Product ${row.name} has both price and counter offer set to zero.`);
                setIsLoading(false);
                return;
              }
              if (price === 0) {
                toast.error(`Product ${row.name} has price set to zero.`);
                setIsLoading(false);
                return;
              }
            }
            if (counterOffer === 0) {
              toast.error(`Product has offer price set to zero.`);
              setIsLoading(false);
              return;
            }
            if (requestedQuantity === 0) {
              toast.error(`Product has Requested Quantity set to zero.`);
              setIsLoading(false);
              return;
            }
            if (counterOffer < 0) {
              toast.error(`Product has Offer Price set to zero.`);
              setIsLoading(false);
              return;
            }
          }
          const productdata = cartProduct.map((row) => ({
            "productid@odata.bind": `${row.productid}`,
            "uomid@odata.bind": `${row._defaultuomid_value}`,
            "transactioncurrencyid@odata.bind": `${row._transactioncurrencyid_value}`,
            opportunityproductname: row.name,
            //priceperunit: row.price,
            priceperunit_base: row.price_base,
            ispriceoverridden: true,
            producttypecode: row.producttypecode,
            description: row.description || null,
            propertyconfigurationstatus: 2,
            priceperunit: row.counterOffer,
            quantity: row.requestedQuantity,
          }));

          const data = {
            accountguid: sessionAccountGUID,
            contactguid: sessionContactGUID,
            opportunityguid: sessionOpportunityGUID,
            productdata: JSON.stringify(productdata),
            totalprice: totalPrice.toString(),
          };

          const config = {
            headers: {
              'Authorization': `Bearer ${tokenData}`,
              'Content-Type': 'application/json',
            },
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
          };

          const response = await axios.post(`${process.env.REACT_APP_CRM_URL}/${process.env.REACT_APP_PLACEORDER_ENTITYNAME}`,
            {
              nyc_name: "Order - " + new Date(),
              [process.env.REACT_APP_PLACEORDER_DATAFIELD]: JSON.stringify(data),
            },
            config
          );

          setIsLoading(false);
          setDisplayThankYouPage(true)
          //toast.success("Order placed successfully");
          // console.log("Quote generated successfully:", response.data);
          await deleteAllProducts();
        }
        else if (atuRecord > 0) {
          for (let row of cartProduct) {
            const price = Number(row.price);
            const counterOffer = row.counterOffer !== undefined ? Number(row.counterOffer) : 0;
            const requestedQuantity = row.requestedQuantity !== undefined ? Number(row.requestedQuantity) : 0;

            if (price === 0) {
              toast.error(`Product has price set to zero.`);
              setIsLoading(false);
              return;
            }
            if (requestedQuantity === 0) {
              toast.error(`Product has Requested Quantity set to zero.`);
              setIsLoading(false);
              return;
            }
          }
          const productdata = cartProduct.map((row) => ({
            atuid: row.nyc_atuid,
            brandGuid: row._nyc_brand_value,
            upc: row.nyc_upc,
            productName: row.nyc_productname,
            counteroffer: row.counterOffer || 0,
            cost: row.nyc_cost,
            price: row.nyc_price,
            supplierGuid: row._nyc_supplier_value,
            requestedQty: row.requestedQuantity,
          }));

          const data = {
            accountguid: sessionAccountGUID,
            contactguid: sessionContactGUID,
            opportunityguid: sessionOpportunityGUID,
            productdata: JSON.stringify(productdata),
            totalprice: totalPrice.toString(),
          };

          const config = {
            headers: {
              'Authorization': `Bearer ${tokenData}`,
              'Content-Type': 'application/json',
            },
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
          };

          const response = await axios.post(`${process.env.REACT_APP_CRM_URL}/${process.env.REACT_APP_PLACEORDER_ENTITYNAME}`,
            {
              nyc_name: "Order - " + new Date(),
              [process.env.REACT_APP_PLACEORDER_DATAFIELD]: JSON.stringify(data),
            },
            config
          );

          setIsLoading(false);
          setDisplayThankYouPage(true)
          toast.success("Order placed successfully");
          // console.log("Quote generated successfully:", response.data);
          await deleteAllProducts();
        }

      } else {
        // console.log("No session customer ID found");
        toast.error("Please provide account ID");
      }
    } catch (error) {
      console.error("Error generating quote:", error);
      setIsLoading(false);
      toast.error(`Something Went Wrong! Please try again`);
      if (error.response) {
        setIsLoading(false);
        console.error("Response Data:", error.response.data);
      }
    }
  };
  const addToCart = (selectedProducts) => {
    // console.log(selectedProducts);
    // console.log(selectedProducts.nyc_atuid);

    var isAtuPresent1 = false;
    var isAtuPresent2 = false;

    if (selectedProducts.nyc_atuid !== undefined) {
      isAtuPresent1 = true;
    }

    cartProduct.forEach((item) => {
      // console.log(item.nyc_atuid);
      if (item.nyc_atuid !== undefined) {
        isAtuPresent2 = true;
      }
    });

    if (isAtuPresent1 !== isAtuPresent2 && cartProduct.length != 0) {
      toast.error("Remove either Replenishment or Inventory record, cannot place order for both types of record at the same time");
      return;
    }

    setCartProduct((prevCartProducts) => {
      const updatedCartProducts = [...prevCartProducts];
      var existingProductIndex;

      if (selectedProducts.nyc_atuid !== null) {
        existingProductIndex = updatedCartProducts.findIndex(
          (cartItem) => cartItem.productnumber === selectedProducts.productnumber
        );
      } else {
        existingProductIndex = updatedCartProducts.findIndex(
          (cartItem) => cartItem.nyc_sku === selectedProducts.nyc_sku
        );
      }

      if (existingProductIndex !== -1) {
        const existingProduct = updatedCartProducts[existingProductIndex];

        // Ensure values are parsed correctly and default to 0 if NaN
        var value1 = parseInt(existingProduct.requestedQuantity) || 0;
        var value2 = parseFloat(selectedProducts.requestedQuantity) || 0;
        var value3 = parseInt(existingProduct.counterOffer) || 0;
        var value4 = parseFloat(selectedProducts.counterOffer) || 0;

        if (value1 === value2) {
          toast.success(`Cart already contains ${value1} quantity with UPC no: ${existingProduct.nyc_upc} and product number: ${existingProduct.productnumber}`);
        } else {
          toast.success(`Cart already contains ${value1} quantity with UPC no: ${existingProduct.nyc_upc} and product number: ${existingProduct.productnumber}, now updated quantity is ${value2}`);
        }

        updatedCartProducts[existingProductIndex] = {
          ...existingProduct,
          requestedQuantity: value2,
          counterOffer: value4,
        };
      } else {
        // Ensure requestedQuantity and counterOffer are numbers and default to 0 if not
        selectedProducts.requestedQuantity = parseFloat(selectedProducts.requestedQuantity) || 0;
        selectedProducts.counterOffer = parseFloat(selectedProducts.counterOffer) || 0;

        updatedCartProducts.push(selectedProducts);
      }

      storeCartDataInSession(updatedCartProducts);
      return updatedCartProducts;
    });
  };


  const handleRequestedQuantityChange = (product, newValue) => {
    setCartProduct((prevCartProduct) => {
      // Update the specific product in the cart
      const updatedCartProduct = prevCartProduct.map((prod) =>
        prod.id === product.id ? { ...prod, requestedQuantity: newValue } : prod
      );
      updateCartDataInCache(updatedCartProduct);
      storeCartDataInSession(updatedCartProduct);
      return updatedCartProduct;
    });
  };

  const handleCounterOfferChange = (product, newValue) => {
    setCartProduct((prevCartProduct) => {
      // Update the specific product in the cart
      const updatedCartProduct = prevCartProduct.map((prod) =>
        prod.id === product.id ? { ...prod, counterOffer: newValue } : prod
      );
      updateCartDataInCache(updatedCartProduct);
      storeCartDataInSession(updatedCartProduct);
      return updatedCartProduct;
    });
  };

  const [editOrder, setEditOrder] = useState([]);

  return (
    <CartInventoryContext.Provider
      value={{
        cartProduct,
        fetchCartDataFromCache,
        getTotalCartItem,
        handleProductCheckboxChange,
        handleStoreInCache,
        deleteProduct,
        deleteAllProducts,
        handleGenerateQuote,
        addToCart,
        customerOption,
        totalPrice,
        setTotalPrice,
        totalMSRP,
        setTotalMSRP,
        setCartProduct,
        isLoading,
        handleRequestedQuantityChange,
        handleCounterOfferChange,
        inputValues,
        setInputValues,
        activeAccount,
        newcustomerOption,
        displayThankYouPage, setDisplayThankYouPage,
        // Amit Change
        infoList,
        setInfoList,
        cartNotification,
        setCartNotification,
        currentPath,
        setCurrentPath,
        selectedRows, setSelectedRows,
        handleAddToCartFromSearch,
        columns,
        columnsRepl,
        visibleColumns,
        visibleColumnsRepl,
        fetchAccountNames,
        fetchNewAccountNames,
        fetchAllActiveAccountNames,
        ownerInfo, setOwnerInfo,
        editOrder, setEditOrder,
        fetchDataFromUserCache
      }}
    >
      {children}
    </CartInventoryContext.Provider>
  );
};

export const useCartInventoryContext = () => {
  const context = useContext(CartInventoryContext);
  if (context === undefined) {
    throw new Error(
      "useCartInventoryContext must be used within a CartInventoryProvider"
    );
  }
  return context;
};
